import { Component, OnInit } from '@angular/core';
import { HeaderService } from './header.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalLogoutComponent } from 'src/app/shared/modal/modal-logout/modal-logout.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public users: any = {};
  data: any;
  token: string;
  dadosUser: any;

  nome: any;
  nomeSplit: any;

  constructor(
    private headerService: HeaderService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal
  ) { }

  ngOnInit() {

    this.token = sessionStorage.getItem("loginAuth");
    
    this.headerService
      .getUser(this.token)
      .then(data => {
        this.nome = data.nome;
        this.nomeSplit = this.nome.split(' ');
        this.nome = `${this.nomeSplit[0]} ${this.nomeSplit[this.nomeSplit.length - 1]}`;
      })
      .catch(error => {});

  }

  openModalLogout() {
    this.modalService.open(ModalLogoutComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

}
